<template>
  <div class="container my-5">
    <basic-details :client="client" />

    <addresses :client="client" />
  </div>
</template>

<script>
import { BasicDetails, Addresses } from './details/index'
import { get } from 'vuex-pathify'

export default {
  components: {
    BasicDetails,
    Addresses
  },

  computed: {
    ...get('clients', ['client'])
  }
}
</script>
